import { useTenantStore } from '@/stores/tenantStore'
import { useSecurityContext } from '../../contexts/SecurityContext'
import { $api, type InferResponse } from '../typedClient'

// Types inferred from OpenAPI schema
export type CrossroadsCompany = InferResponse<
  '/crossroads/network/companies/',
  'get'
>[number]

export function useCrossroadsCompanies() {
  const { selectedTenant } = useTenantStore()
  const { hasGravitateAccess } = useSecurityContext()

  return $api.useQuery(
    'get',
    '/crossroads/network/companies/',
    {},
    {
      enabled: !!selectedTenant?.name && hasGravitateAccess(),
      staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    },
  )
}
